import React, { useState } from 'react';
import AuthPageContainer from './container';
import SignupWithPromo from '../login/signupWithPromo';
import LoginButton from './LoginButton';
import LoginFooter from './LoginFooter';

export default function SignupPage({ staticContext, match }) {
  const [isPostSignup, setIsPostSignup] = useState(false);
  const promo =
    (staticContext && staticContext.params && staticContext.params.promo) ||
    (match && match.params && match.params.promo);

  return (
    <AuthPageContainer
      renderNav={isPostSignup ? null : LoginButton}
      renderFooter={isPostSignup ? null : LoginFooter}
    >
      <SignupWithPromo
        promo={promo}
        onPostSignup={() => setIsPostSignup(true)}
      />
    </AuthPageContainer>
  );
}
